// try to fix this typing later
// type MessageHandler<T extends JsonObject> = Readonly<{
//   postMessage: (payload: T) => void;
// }>;

// use any here for now
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type MessageHandler<T = any> = Readonly<{
    postMessage: (payload: any) => void;
  }>;

type EmptyObject = Record<string, never>;

// TODO: Import from @noom/noom-contracts when the correct path is available
// import { NativeInteropMessageProto } from "@noom/noom-contracts/noom_contracts/mobile/webview/interop";
type NativeInteropMessageProto = any;

export type NativePurchaseInfo = {
  productData: {
    productId: string;
    subscriptionLength: number;
  };
  programAvailability: {
    curriculum: string;
    isAvailable: boolean;
    language: string;
  };
  tracking: {
    routeId: string;
    tier: string;
  };
};

export type DynamicSurveyAnswer = {
  questionId: string;
  answerSlugs?: string[];
  answerText?: string;
};

export type DynamicSurveyCompletedPayload = {
  surveysCompleted: {
    surveyId: string;
    surveyExperienceSlug: string;
    surveyAnswers: DynamicSurveyAnswer[];
  }[];
};

export type IOSMessageHandlers =
  | Readonly<{
      programSwitchComplete?: MessageHandler<EmptyObject>;

      buyflowExit?: MessageHandler<EmptyObject>;

      webviewExit?: MessageHandler<EmptyObject>;

      /**
       * The IOS webview client has a backPrevented variable that controls whether we show a back button or not.
       * This message handler acts as a setter for that variable
       *
       */
      webviewPreventsGoingBack?: MessageHandler<{ backPrevented: boolean }>;

      buyflowPurchase?: MessageHandler<EmptyObject>;

      buyflowPurchaseProduct?: MessageHandler<NativePurchaseInfo>;

      buyflowPurchaseNoDetails?: MessageHandler<{
        forceExperimentsToAssign?: {
          name: string;
          variation: string;
        }[];
      }>;

      buyflowPurchaseCompleted?: MessageHandler<EmptyObject>;
      freemiumBuyflowComplete?: MessageHandler<EmptyObject>;
      checkInModuleSelection?: MessageHandler<string>;
      checkInSurveyCompleted?: MessageHandler<DynamicSurveyCompletedPayload>;
      sendNativeInteropMessage?: MessageHandler<NativeInteropMessageProto>;
    }>
  | undefined;

export type IOSAnalyticsMessageHandler =
  | Readonly<{
      postMessage: (payload: string) => void | Promise<unknown>;
    }>
  | undefined;

export type IOSAnalyticsMessageHandlers =
  | Readonly<{
      NativeAnalyticsService?: Readonly<{
        sendAppEvent?: IOSAnalyticsMessageHandler;
      }>;
      "NativeAnalyticsService.sendAppEvent"?: IOSAnalyticsMessageHandler;
    }>
  | undefined;

export function getIOSMessageHandlers() {
  return (window as any).webkit?.messageHandlers as IOSMessageHandlers;
}

export function getIOSAnalyticsMessageHandler() {
  const messageHandlers = getIOSMessageHandlers() as IOSAnalyticsMessageHandlers;

  return (
    messageHandlers?.NativeAnalyticsService?.sendAppEvent ??
    messageHandlers?.["NativeAnalyticsService.sendAppEvent"]
  );
}

export type AndroidMessageHandlers =
  | Readonly<{
      buyflowExit?: (payload?: any) => void;
      webviewExit?: (payload?: any) => void;
      programSwitchComplete?: () => void;
      trackPurchaseCompleted?: (payload: string) => void;
      buyflowPurchase?: () => void;
      buyflowPurchaseCompleted?: () => void;
      buyflowPurchaseProduct?: (payload: string) => void; // JSON string of NativePurchaseInfo object
      sendNativeInteropMessage?: (payload: string) => void;
    }>
  | undefined;

export function getAndroidMessageHandlers() {
  return (window as any).Android as AndroidMessageHandlers;
}
